<template>
  <div class="container">
    <div class="home" v-if="type == 1">
      <div class="top-box">
        <div class="flexrbc">
          <div class="flexr0c">
            <div class="title-label"></div>
            <div class="title">非预申报矿产调运</div>
          </div>
          <div class="flexr0c">
            <div v-if="preDeclare == 0" class="addOre flexrcc" @click="addPre">
              <img src="../../assets/imgs/home/add.png" alt />
              <div class="btn">发放调运单</div>
            </div>
          </div>
        </div>
      </div>
      <div class="search-box flexr0c">
        <div class="flexr0c dispatch-time">
          <div class="label">调运时间</div>
          <Row>
            <Col span="12">
            <DatePicker :editable="false" :value="dateValue" format="yyyy/MM/dd" type="daterange" placement="bottom-end" placeholder="选择日期" style="width: 240px" @on-change="handleChange"></DatePicker>
            </Col>
          </Row>
        </div>
        <div class="flexr0c select-box">
          <div class="label">交易矿种</div>
          <Select v-model="select1" style="width: 140px" @on-change="getList(1)">
            <Option v-for="item in oreList" :value="item.value" :key="item.index">{{ item.label }}</Option>
          </Select>
        </div>
        <div class="flexr0c search-item">
          <div class="label">需方企业</div>
          <Input v-model="needCom" placeholder="" style="width: 292px" @on-blur="getList(1)" @on-enter="getList(1)">
          <Icon type="ios-search" slot="suffix" />
          </Input>
        </div>
      </div>
      <div class="table-box">
        <div class="table">
          <Table max-height="" :loading="loading1" border stripe :columns="tableHead" :data="tableData" @cell-click="showAllPlateNum">
            <template slot-scope=" { row }" slot="notPassCount">
              <div class="rejected">{{ row.notPassCount }}</div>
            </template>
            <template slot-scope="{ row }" slot="enterpriseName">
              <div class="comName">{{ row.enterpriseName }}</div>
            </template>
            <template slot-scope="{ row }" slot="buyerName">
              <div class="comName">{{ row.buyerName }}</div>
            </template>
            <template class="flexr0c" slot-scope="{ row, index }" slot="action">
              <div class="flexr0c icon-box" @mouseenter="hover(index)">
                <div class="flexr0c" @click="look(row.id)">
                  <div class="iconfont">&#xe604;</div>
                  <div class="tips">查看</div>
                </div>
              </div>
            </template>
          </Table>
          <div style="margin: 10px; overflow: hidden">
            <div style="float: right">
              <Page :total="total" :page-size="pageSize" :current="1" @on-change="changePage" show-elevator show-total></Page>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="dispatch-detail" v-if="type == 2">
      <div class="top flexr0c">
        <img class="addr" src="../../assets/imgs/home/location.png" alt="" />
        <div class="title" @click="manage">非预申报矿产调运</div>
        <img class="arrow" src="../../assets/imgs/home/rightarrow.png" alt="" />
        <div class="title">查看详情</div>
      </div>
      <div class="top-card flexr">
        <div class="card-left flexc0s">
          <div class="label">过站验证码</div>
          <div class="value">{{ detailInfo.checkCode }}</div>
          <div class="time">
            剩余执行时间：<span class="red">{{ detailInfo.remainTime }}</span>
          </div>
        </div>
        <div class="card-right flexr0c">
          <div class="flexc0s">
            <div class="label flexr0c">
              <div class="two-word">矿<span>种：</span></div>
              <div>{{ detailInfo.oreName }}</div>
            </div>
            <div class="label flexr0c">
              <div>调运时间：</div>
              <div>{{ detailInfo.createTime }}</div>
            </div>
            <div class="label flexr0c">
              <div class="three-word">有效<span>期：</span></div>
              <div>{{ detailInfo.validHours }}小时</div>
            </div>
          </div>
          <div class="flexc0s">
            <div class="label flexr0c">
              <div class="three-word">装运<span>地：</span></div>
              <div>{{ detailInfo.sourceArea }}</div>
            </div>
            <div class="label flexr0c">
              <div class="three-word">目的<span>地：</span></div>
              <div>{{ detailInfo.destArea }}</div>
            </div>
            <div class="label flexr0c">
              <div>需方企业：</div>
              <div>{{ detailInfo.buyerName }}</div>
            </div>
          </div>
          <img v-if="failure" src="../../assets/imgs/home/failure.png" alt="" />
        </div>
      </div>
      <div class="table">
        <Table max-height="" :loading="loading2" border stripe :columns="tableHead2" :data="tableData2">
          <template slot-scope="{ row }" slot="state">
            <div :class="row.state == '未过站' ? 'red' : 'green'">{{ row.state }}</div>
          </template>
        </Table>
      </div>
    </div>

    <div class="no-data" v-if="type == 3">
      <div class="top-box">
        <div class="flexrbc">
          <div class="flexr0c">
            <div class="title-label"></div>
            <div class="title">非预申报矿产调运</div>
          </div>
        </div>
      </div>
      <div class="search-box flexr0c">
        <div class="flexr0c dispatch-time">
          <div class="label">调运时间</div>
          <Row>
            <Col span="12">
            <DatePicker :editable="false" :value="dateValue" format="yyyy/MM/dd" type="daterange" placement="bottom-end" placeholder="选择日期" style="width: 240px" @on-change="handleChange"></DatePicker>
            </Col>
          </Row>
        </div>
        <div class="flexr0c select-box">
          <div class="label">交易账户</div>
          <Select v-model="select1" style="width: 140px" @on-change="getList(1)">
            <Option v-for="(item, index) in oreList" :value="item.value" :key="item.index">{{ item.label }}</Option>
          </Select>
        </div>
        <div class="flexr0c search-item">
          <div class="label">需方企业</div>
          <Input v-model="needCom" placeholder="" style="width: 292px">
          <Icon type="ios-search" slot="suffix" />
          </Input>
        </div>
      </div>
      <div class="no-data-box flexccc">
        <img src="../../assets/imgs/home/no-data.png" alt="" />
        <div class="no-data-txt">暂无数据</div>
      </div>
    </div>

    <Modal v-model="numModal" title="车牌号" width="300" class-name="vertical-center-modal" :footer-hide="true">
      <p slot="header" style="text-align: center">
        <span style="color: white; font-size: 18px; font-weight: 600">车牌号</span>
      </p>
      <p v-for="(item, index) in numList" :key="index" style="text-align: center">{{item.plateNum}}</p>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "notpreDeclare",
  components: {},
  data () {
    return {
      numModal: false,
      numList: [],
      type: 1,
      dateValue: [],
      select1: "",
      select2: "全部",
      oreList: [
        {
          value: "全部",
          label: "全部",
        },
      ],
      needCom: "",
      preId: "",
      loading1: false,
      loading2: false,
      total: 0,
      pageSize: 12,
      tips1: false,
      tips2: false,
      end: false,
      failure: false,
      detailInfo: {},
      tableHead: [
        {
          title: "车牌号",
          key: "showPlateNum",
          fixed: "left",
          width: 110,
          render: (h, params) => {
            if (params.row.showPlateNum) {
              // passTruckList多条可点击
              if (params.row.passTruckList.length > 1) {
                return h("span", {
                  style: {
                    color: "#2C4D9C",
                    cursor: "pointer"
                  },
                  on: {
                    click: (e) => {
                      e.stopPropagation(); //阻止冒泡
                      this.showAllPlateNum(params.row.passTruckList);
                    },
                  },
                }, params.row.showPlateNum);
              } else {
                return h("span", {}, params.row.showPlateNum)
              }
            }
          }
        },
        {
          title: "过站码",
          key: "checkCode",
          width: 90,
          resizable: true,
        },
        {
          title: "调运时间",
          key: "transTime",
          width: 170,
          resizable: true,
        },
        {
          title: "交易矿种",
          key: "oreName",
          width: 140,
          resizable: true,
        },
        {
          title: "调运量(吨)",
          key: "totalWeight",
          width: 100,
          resizable: true,
        },
        {
          title: "调运车次",
          key: "allPassCount",
          width: 90,
          resizable: true,
        },
        {
          title: "未过站车次",
          slot: "notPassCount",
          width: 110,
          resizable: true,
        },
        {
          title: "剩余有效时间",
          key: "lastTime",
          width: 120,
          resizable: true,
        },
        {
          title: "调运企业",
          slot: "enterpriseName",
          width: 220,
          resizable: true,
        },
        {
          title: "需方企业",
          slot: "buyerName",
          width: 220,
          resizable: true,
        },
        {
          title: "操作",
          slot: "action",
          fixed: "right",
          width: 120,
          resizable: true
        },
      ],
      tableData: [],
      tableHead2: [
        {
          title: "车牌号码",
          key: "plateNum",
          width: 170,
          resizable: true,
        },
        {
          title: "车辆载重(吨)",
          key: "notPassStationTruckWeight",
          width: 170,
          resizable: true,
        },
        {
          title: "司机姓名",
          key: "driverName",
          width: 170,
          resizable: true,
        },
        {
          title: "司机联系方式",
          key: "driverPhone",
          width: 170,
          resizable: true,
        },
        {
          title: "过站状态",
          slot: "state",
          width: 170,
          resizable: true,
        },
        {
          title: "过站时间",
          key: "passTime",
          width: 200,
          resizable: true,
        },
        {
          title: "过站净重(吨)",
          key: "netWeight",
          width: 170,
          resizable: true,
        },
        {
          title: "过站税费(吨)",
          key: "payMoney",
          width: 170,
          resizable: true,
        },
        {
          title: "计量站",
          key: "stationName",
          width: 170,
          resizable: true,
        },
      ],
      tableData2: [],
      preDeclare: -1, //预申报（1）/非预申报（0）判断
    };
  },
  methods: {
    showAllPlateNum (list) {
      this.numModal = true;
      this.numList = list || [];
    },
    dateFormat (fmt, date) {
      let ret;
      const opt = {
        "Y+": date.getFullYear().toString(), // 年
        "m+": (date.getMonth() + 1).toString(), // 月
        "d+": date.getDate().toString(), // 日
        "H+": date.getHours().toString(), // 时
        "M+": date.getMinutes().toString(), // 分
        "S+": date.getSeconds().toString(), // 秒
        // 有其他格式化字符需求可以继续添加，必须转化成字符串
      };
      for (let k in opt) {
        ret = new RegExp("(" + k + ")").exec(fmt);
        if (ret) {
          fmt = fmt.replace(ret[1], ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, "0"));
        }
      }
      return fmt;
    },
    getHour (minutes) {
      if (minutes <= 0) {
        return 0;
      }
      let hour = parseInt(minutes / 60);
      let minute = minutes % 60;
      return hour + "小时" + minute + "分钟";
    },
    lookDetail: function () {
      this.type = 1;
    },
    changePage (page) {
      this.getList(page);
    },
    hover (index) {
      this.hoverIndex = index;
    },
    addPre () {
      if (window.sessionStorage.getItem("from")) {
        window.sessionStorage.removeItem("from");
      }
      this.$router.push({
        path: "/unWayBill",
      });
    },
    look (id) {
      this.getDetail(id);
      this.getDetailList(id);
    },
    edit (index) { },
    dispatch (index) { },
    del (index) { },
    manage () {
      this.type = 1;
    },
    handleChange (daterange) {
      this.dateValue = daterange;
      this.getList(1);
    },
    getList (index) {
      this.loading1 = true;
      var session = JSON.parse(localStorage["session"]);
      let data = {
        sessionId: session.sessionId,
        modeCode: "Wav9Fz2yVorSYuZhhYd67JMQGU1c3N0C",
        userId: session.userId,
        enterpriseId: session.enterpriseId,
        pageIndex: index,
        pageSize: this.pageSize,
      };
      this.dateValue[0] ? (data.transTime = this.dateValue.join("~").replace(/\//g, "-")) : data;
      this.select1 && this.select1 != "全部" ? (data.oreId = this.select1) : data;
      this.needCom ? (data.buyerName = this.needCom) : data;
      this.$http.post(data).then((res) => {
        if (res.code == 1) {
          res.data.list.forEach((item) => {
            item.showPlateNum = item.passTruckList.length > 0 && item.passTruckList[0].plateNum || "";
            item.lastTime = this.getHour(item.minutes);
          });
          this.total = res.data.count;
          this.tableData = res.data.list;
        } else {
          this.$Message["error"]({
            background: true,
            content: res.msg,
          });
        }
        this.loading1 = false;
      });
    },
    getDetail (id) {
      var session = JSON.parse(localStorage["session"]);
      let data = {
        sessionId: session.sessionId,
        modeCode: "ysCPadRU5W9OXdYZFpAW11hrVXEH5dSz",
        id: id,
      };
      this.$http.post(data).then((res) => {
        if (res.code == 1) {
          res.data.remainTime = this.getHour(res.data.minutes);
          this.detailInfo = res.data;
          if (res.data.minutes <= 0) {
            this.failure = true;
          } else {
            this.failure = false;
          }
          this.type = 2;
        } else {
          this.$Message["error"]({
            background: true,
            content: res.msg,
          });
        }
      });
    },
    getDetailList (id) {
      this.loading2 = true;
      var session = JSON.parse(localStorage["session"]);
      let data = {
        sessionId: session.sessionId,
        modeCode: "T5Ij7VAQuPJa6OTK76lFgRCWhtnp4xBl",
        id: id,
      };
      this.$http.post(data).then((res) => {
        if (res.code == 1) {
          res.data.forEach((item) => {
            if (item.state == 0) {
              item.state = "未过站";
            } else {
              item.state = "已过站";
            }
          });
          this.tableData2 = res.data;
        } else {
          this.$Message["error"]({
            background: true,
            content: res.msg,
          });
        }
        this.loading2 = false;
      });
    },
    getOreList () {
      var session = JSON.parse(localStorage["session"]);
      let data = {
        sessionId: session.sessionId,
        enterpriseId: session.enterpriseId,
        modeCode: "8Nj3MDYFYm6AMtHz8dYeDsMk7bEAC8Cg",
      };
      this.$http.post(data).then((res) => {
        if (res.code == 1) {
          res.data.forEach((item) => {
            let obj = {};
            obj.value = item.oreId;
            obj.label = item.oreName;
            this.oreList.push(obj);
          });
        } else {
          this.$Message["error"]({
            background: true,
            content: res.msg,
          });
        }
      });
    },
  },
  created () {
    let date2 = this.dateFormat("YYYY-mm-dd", new Date());
    let date1 = this.dateFormat("YYYY-mm-", new Date()) + "01";
    this.dateValue.push(date1);
    this.dateValue.push(date2);
    this.session = JSON.parse(localStorage["session"]);
    this.preDeclare = this.session.isNeedContract;
    this.getList(1);
    this.getOreList();
  }
};
</script>

<style lang="less" scoped>
.container {
  .home {
    .top-box {
      background-image: linear-gradient(180deg, #ffffff 0%, #e8e9ea 100%);
      border-radius: 10px 10px 0 0;
      width: 100%;
      height: 40px;

      & > div {
        height: 100%;
        width: 928px;
        margin: 0 auto;
      }

      .title-label {
        width: 4px;
        height: 14px;
        background: #2c59c3;
      }

      .title {
        font-family: PingFangSC-Semibold;
        font-size: 16px;
        color: #2c59c3;
        letter-spacing: 0.4px;
        margin-left: 6px;
      }

      .addOre {
        background-image: linear-gradient(180deg, #b4ec51 0%, #429321 100%);
        border: 1px solid #4c9b25;
        border-radius: 6px;
        width: 110px;
        height: 30px;
        cursor: pointer;

        &:hover {
          background-image: linear-gradient(180deg, #c4ff5b 0%, #4aa824 100%);
        }

        img {
          width: 14px;
          height: 14px;
          margin-right: 5px;
        }

        .btn {
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #ffffff;
          letter-spacing: 0.35px;
        }
      }

      .export {
        width: 80px;
        height: 30px;
        line-height: 30px;
        background-image: linear-gradient(180deg, #91caff 0%, #0074d6 97%);
        border: 1px solid #006bc4;
        border-radius: 6px;
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #ffffff;
        letter-spacing: 0.35px;
        text-align: center;
        margin-left: 14px;
      }
    }

    .search-box {
      height: 74px;

      .label {
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #616c84;
        letter-spacing: 0;
        margin-right: 10px;
      }

      .select-box,
      .search-item,
      .dispatch-time {
        margin-left: 25px;
      }

      /deep/.ivu-select-selected-value {
        height: 38px;
        line-height: 38px;
        text-align: left;
      }

      /deep/.ivu-select-selection,
      /deep/.ivu-input {
        height: 38px;
        // border: 1px solid #CCD1DD;
        box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.17);
        border-radius: 4px;
      }

      /deep/ .ivu-input-suffix i {
        line-height: 38px;
      }

      /deep/.ivu-date-picker-focused input,
      /deep/.ivu-date-picker-focused input {
        font-size: 14px;
      }

      /deep/.ivu-select-selected-value,
      /deep/.ivu-select-item {
        text-align: start;
      }

      /deep/.ivu-input-with-suffix {
        cursor: pointer;
      }

      /deep/.ivu-select-selection {
        height: 38px;
        background: #ffffff;
        // border: 1px solid #DFDFDF;
        box-shadow: inset 0 4px 8px 0 rgba(0, 0, 0, 0.07);
        border-radius: 8px;
      }

      /deep/.ivu-select-placeholder,
      /deep/.ivu-select-selected-value {
        height: 38px;
        line-height: 38px;
        padding-left: 24px;
        text-align: start;
      }

      /deep/.ivu-input-suffix {
        line-height: 38px;
      }

      /deep/.ivu-input-with-suffix {
        height: 38px;
        line-height: 38px;
        padding-left: 24px;
        background: #ffffff;
        // border: 1px solid #DFDFDF;
        box-shadow: inset 0 4px 8px 0 rgba(0, 0, 0, 0.07);
        border-radius: 8px;
      }
    }

    .table-box {
      background: #ffffff;
      box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.1);
      border-radius: 10px;
      border-radius: 10px;
      min-height: 534px;
      overflow: hidden;

      .table {
        width: 928px;
        margin: 18px 0 0 26px;

        /deep/.ivu-table-cell {
          padding-left: 12px;
          overflow: unset;
        }

        .rejected {
          color: #d0021b;
        }
        .comName {
          width: 190px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }

        .order-id {
          cursor: pointer;
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #4a90e2;
        }

        .ckeck-state {
          & > .iconfont {
            margin-right: 6px;
          }

          .checked {
            width: 15px;
            height: 15px;
            margin-right: 6px;
          }

          .rejected-icon {
            margin-left: 8px;
            width: 15px;
            height: 15px;
          }
        }

        .onSell {
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #27ae60;
          letter-spacing: 0;
          margin-left: 5px;
        }

        .stopSell {
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #d0021b;
          letter-spacing: 0;
          margin-left: 5px;
        }

        .icon-box {
          position: relative;

          & > div {
            position: relative;

            // &:hover {
            //     color: #4a90e2;
            // }
          }

          .iconfont {
            cursor: pointer;

            &:last-child {
              margin-right: 0;
            }
          }

          .tips {
            font-family: PingFangSC-Regular;
            font-size: 14px;
            color: #4a4a4a;
            letter-spacing: 0;
            margin: 0 15px 0 5px;
            cursor: pointer;
          }

          .dispatch {
            color: #5cae50;
          }

          .disable {
            color: #9b9b9b;
          }

          .dialog-box {
            width: 110px;
            height: 46px;
            border-radius: 4px;
            position: relative;
            background: #ffffff;
            box-shadow: 0 14px 30px 0 rgba(0, 0, 0, 0.14);
            left: 15px;
            padding: 10px;
            box-sizing: border-box;

            &::before {
              content: "";
              width: 0;
              height: 0;
              border: 8px solid;
              position: absolute;
              left: -16px;
              top: 18px;
              border-color: transparent #fff transparent transparent;
            }

            p {
              font-family: PingFangSC-Regular;
              font-size: 12px;
              color: #000000;
              line-height: 24px;
            }
          }
        }
      }
    }
  }

  .dispatch-detail {
    width: 100%;
    background: #ffffff;
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    overflow: auto;

    .top {
      background: #fff;

      .addr {
        width: 14px;
        height: 18px;
        margin: 15px;
        margin-right: 8px;
      }

      .title {
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #adb2bc;
        letter-spacing: 0.26px;
        cursor: pointer;
      }

      .arrow {
        width: 7px;
        height: 14px;
        margin: 0 10px;
      }
    }

    .top-card {
      width: 928px;
      height: 158px;
      border: 1px solid #ebedf3;
      margin: 15px 26px;

      .card-left {
        width: 257px;
        height: 100%;
        border-right: 1px solid #ebedf3;
        padding: 14px 24px;
        box-sizing: border-box;

        .label {
          font-family: PingFangSC-Regular;
          font-size: 16px;
          color: #8b93a7;
          letter-spacing: 0.4px;
        }

        .value {
          font-family: Impact;
          font-size: 36px;
          color: #d0021b;
          letter-spacing: 0.77px;
        }

        .time {
          font-family: PingFangSC-Semibold;
          font-size: 16px;
          color: #8b93a7;
          letter-spacing: 0;

          .red {
            color: #d0021b;
          }
        }
      }

      .card-right {
        padding: 40px 24px;
        box-sizing: border-box;
        position: relative;

        & > div {
          width: 310px;

          .label {
            margin-bottom: 6px;

            & > div:first-child {
              font-family: PingFangSC-Semibold;
              font-size: 16px;
              color: #8b93a7;
              width: 80px;
              text-align: right;
            }

            & > div:last-child {
              font-family: PingFangSC-Semibold;
              font-size: 16px;
              color: #4a4a4a;
              letter-spacing: 0;
            }

            .two-word {
              letter-spacing: 30px;

              span {
                letter-spacing: 0;
              }
            }

            .three-word {
              letter-spacing: 8px;

              span {
                letter-spacing: 0;
              }
            }
          }
        }

        img {
          position: absolute;
          top: 15px;
          right: 15px;
        }
      }
    }

    .table {
      width: 928px;
      margin: 18px 0 20px 26px;

      .red {
        color: #d0021b;
      }

      .green {
        color: #5cae50;
      }

      .look-box {
        cursor: pointer;

        .tips {
          margin-left: 6px;
        }
      }
    }
  }

  .no-data {
    .top-box {
      background-image: linear-gradient(180deg, #ffffff 0%, #e8e9ea 100%);
      border-radius: 10px 10px 0 0;
      width: 100%;
      height: 40px;

      & > div {
        height: 100%;
        width: 928px;
        margin: 0 auto;
      }

      .title-label {
        width: 4px;
        height: 14px;
        background: #2c59c3;
      }

      .title {
        font-family: PingFangSC-Semibold;
        font-size: 16px;
        color: #2c59c3;
        letter-spacing: 0.4px;
        margin-left: 6px;
      }

      .addOre {
        background-image: linear-gradient(180deg, #b4ec51 0%, #429321 100%);
        border: 1px solid #4c9b25;
        border-radius: 6px;
        width: 110px;
        height: 30px;
        cursor: pointer;

        &:hover {
          background-image: linear-gradient(180deg, #c4ff5b 0%, #4aa824 100%);
        }

        img {
          width: 14px;
          height: 14px;
          margin-right: 5px;
        }

        .btn {
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #ffffff;
          letter-spacing: 0.35px;
        }
      }

      .export {
        width: 80px;
        height: 30px;
        line-height: 30px;
        background-image: linear-gradient(180deg, #91caff 0%, #0074d6 97%);
        border: 1px solid #006bc4;
        border-radius: 6px;
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #ffffff;
        letter-spacing: 0.35px;
        text-align: center;
        margin-left: 14px;
      }
    }

    .search-box {
      height: 74px;

      .label {
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #616c84;
        letter-spacing: 0;
        margin-right: 10px;
      }

      .select-box,
      .search-item,
      .dispatch-time {
        margin-left: 25px;
      }

      /deep/.ivu-select-selected-value {
        height: 38px;
        line-height: 38px;
        text-align: left;
      }

      /deep/.ivu-select-selection,
      /deep/.ivu-input {
        height: 38px;
        // border: 1px solid #CCD1DD;
        box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.17);
        border-radius: 4px;
      }

      /deep/ .ivu-input-suffix i {
        line-height: 38px;
      }

      /deep/.ivu-date-picker-focused input,
      /deep/.ivu-date-picker-focused input {
        font-size: 14px;
      }

      /deep/.ivu-select-selected-value,
      /deep/.ivu-select-item {
        text-align: start;
      }

      /deep/.ivu-input-with-suffix {
        cursor: pointer;
      }

      /deep/.ivu-select-selection {
        height: 38px;
        background: #ffffff;
        // border: 1px solid #DFDFDF;
        box-shadow: inset 0 4px 8px 0 rgba(0, 0, 0, 0.07);
        border-radius: 8px;
      }

      /deep/.ivu-select-placeholder,
      /deep/.ivu-select-selected-value {
        height: 38px;
        line-height: 38px;
        padding-left: 24px;
        text-align: start;
      }

      /deep/.ivu-input-suffix {
        line-height: 38px;
      }

      /deep/.ivu-input-with-suffix {
        height: 38px;
        line-height: 38px;
        padding-left: 24px;
        background: #ffffff;
        // border: 1px solid #DFDFDF;
        box-shadow: inset 0 4px 8px 0 rgba(0, 0, 0, 0.07);
        border-radius: 8px;
      }
    }

    .no-data-box {
      background-color: #fff;
      height: 662px;
      width: 980px;
      box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.1);
      border-radius: 10px;

      img {
        width: 210px;
        height: 140px;
      }

      .no-data-txt {
        margin-top: 20px;
        font-family: PingFangSC-Medium;
        font-size: 12px;
        color: #9999a8;
        letter-spacing: 0.22px;
      }
    }
  }
}

.flex_between > div:nth-child(2) {
  margin-left: 10%;
}

/deep/.ivu-table-stripe .ivu-table-body tr:nth-child(2n) td,
.ivu-table-stripe .ivu-table-fixed-body tr:nth-child(2n) td {
  background-color: rgba(236, 241, 247, 0.4);
}

/deep/.ivu-table-stripe .ivu-table-body tr.ivu-table-row-hover td,
.ivu-table-stripe .ivu-table-fixed-body tr.ivu-table-row-hover td {
  background: rgba(255, 255, 235, 0.15) !important;
}

/deep/.ivu-table-row-hover {
  background: rgba(255, 255, 235, 0.15) !important;
}

/deep/ .vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;
  .ivu-modal {
    top: 0;
  }
}

/deep/ .ivu-modal-header {
  background-image: linear-gradient(180deg, #5792e3 0%, #2c59c3 100%);
  height: 48px;
  color: #fff;
}

/deep/ .ivu-modal-close .ivu-icon-ios-close {
  color: #fff;
}

.blueColor {
  color: #2c59c3;
}
</style>
